export default {
  //* patchTagsPersonalizzati ---------------------------------------------------------------------------------------------------------------

  async patchTagsPersonalizzati({ rootGetters }, payload) {
    // @payload needs the id of the quotes and all the attributes needed
    /*
			! ATTENTION:
			control the data being patched otherwise the patch oper. is not permitted
		*/
    // otherwise the patch is not permitted
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      user = rootGetters["auth/getUser"],
      data = JSON.stringify({
        personalizedTags: payload,
      });
    tok = "Bearer " + tok; // composition of the token
    user = JSON.parse(user);
    var response = await fetch(base_address + "/editCamping/" + user.camping, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    });
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* loadTagsPersonalizzati ---------------------------------------------------------------------------------------------------------------

  async loadTagsPersonalizzati({ rootGetters, commit }) {
    // @payload needs the id of the quotes and all the attributes needed
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      user = rootGetters["auth/getUser"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    user = JSON.parse(user);
    const response = await fetch(base_address + "/getCamping/" + user.camping, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      const tags_ret = resp_json.personalizedTags
        ? resp_json.personalizedTags
        : [["test", "eee"]];
      // commit("setTagsPersonalizzati", tags_ret);
      // localStorage.setItem("tagsPersonalizzati", JSON.stringify(tags_ret));
      return tags_ret;
    } else {
      return [];
    }
  },
  //* loadOnlyTagsPersonalizzati ---------------------------------------------------------------------------------------------------------------

  async loadOnlyTagsPersonalizzati({ rootGetters, commit }) {
    // @payload needs the id of the quotes and all the attributes needed
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      user = rootGetters["auth/getUser"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    user = JSON.parse(user);
    const response = await fetch(base_address + "/getCamping/" + user.camping, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      const tags = resp_json.personalizedTags
        ? resp_json.personalizedTags
        : ["test"];

      var tmp = [];
      tags.forEach((e) => tmp.push(e[0]));
      return tmp;
    } else {
      return [];
    }
  },

  //* patchTagsPersonalizzatiPreventivi ---------------------------------------------------------------------------------------------------------------

  async patchTagsPersonalizzatiPreventivi({ rootGetters }, payload) {
    // @payload needs the id of the quotes and all the attributes needed
    /*
			! ATTENTION:
			control the data being patched otherwise the patch oper. is not permitted
		*/
    // otherwise the patch is not permitted
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      user = rootGetters["auth/getUser"],
      data = JSON.stringify({
        personalizedQuoteTags: payload,
      });
    tok = "Bearer " + tok; // composition of the token
    user = JSON.parse(user);
    var response = await fetch(base_address + "/editCamping/" + user.camping, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    });
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* loadTagsPersonalizzatiPreventivi ---------------------------------------------------------------------------------------------------------------

  async loadTagsPersonalizzatiPreventivi({ rootGetters, commit }) {
    // @payload needs the id of the quotes and all the attributes needed
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      user = rootGetters["auth/getUser"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    user = JSON.parse(user);
    const response = await fetch(base_address + "/getCamping/" + user.camping, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      const tags_ret = resp_json.personalizedQuoteTags
        ? resp_json.personalizedQuoteTags
        : [["test", "eee"]];
      commit("setTagsPersonalizzatiPreventivi", tags_ret);
      localStorage.setItem(
        "tagsPersonalizzatiPreventivi",
        JSON.stringify(tags_ret)
      );
    }
  },
};
